const BlockedWarningMessages = {
    // console messages for blocked invitation
    Invitation: 'Live Chat has been blocked on this page.',
    ExitPopup: 'Exit Popup has been blocked on this page.',
    IP: 'Your IP has been blocked for Live Chat.',
    SMS: 'Failed to start sms chat - Phone Number was blocked. Phone Number:',
    DuringOfficeHours: 'The specified company does not monitor chats after business hours.',
    AfterOfficeHours: 'The specified company only monitors chats after business hours.'
};
export default BlockedWarningMessages;
